<template>
    <div class="container selectdiv">
        <span class="inputName">{{label}}</span>
        <label>
            <select @change="changeHandler" v-model="selected" :disabled="disabled" :required="this.isRequired">
                <option v-for="option in options" v-bind:value="option.text" v-bind:key="option.value">
                    {{ option.text }}
                </option>
            </select>
        </label>
    </div>
</template>

<script>
    export default {
        name: "SelectDetail",
        data: function () {
            return {
                selected: ''
            };
        },
        props: {
            placeholder: {
                type: String,
                required: false
            },
            disabled: {
                type: Boolean,
                required: false
            },
            label: {
                type: String,
                required: false
            },
            width: {
                type: String,
                required: false,
                default: null
            },
            initial: {
                type: String,
                required: false,
            },
            options: {
                type: Array,
                required: true,
            },
            required: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            if(typeof this.initial !== 'undefined'){
                this.selected = this.initial;
            }else if(this.options.length > 0){
                this.selected = this.options[0]['text']
            }
        },
        computed:{
          isRequired(){
              return this.required && this.initial === '';
          }
        },
        methods:{
            changeHandler(){
                if(this.selected === '' && this.required){
                    this.isRequired = true;
                }else{
                    this.isRequired = false;
                }
                this.$emit('change',this.selected);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        position: relative;
    }

    .inputName {
        position: absolute;
        left: 10px;
        top: 5px;
        font-size: 11px;
        color: #777;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -o-user-select: none;
    }

    select {
        padding: 1.2em 0.5em 0.5em 0.5em;
        font-size: 15px;
        width: 100%;
        border-color: $grey;
    }

    select:disabled {
        background: transparent;
        border-color: transparent;
        border-bottom: 1px solid #ccc;
        color: black;
    }

    select::-ms-expand {
        display: none;
    }

    .selectdiv:after {
        content: '<>';
        font: 17px "Consolas", monospace;
        color: #333;
        -webkit-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        transform: rotate(90deg);
        right: 11px;
        /*Adjust for position however you want*/

        top: 13px;
        padding: 0 0 2px;

        position: absolute;
        pointer-events: none;
    }

    .selectdiv select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }

    :required {
        border: 2px solid $pink;
    }

</style>